import checkIcon from "../errors/images/check-icon.svg";
import React, { useEffect, useState, useRef } from "react";
import { HOST_URL, LOCAL_STORAGE_TOKEN_KEY } from "../../consts";
import axios from "axios";
import "./errors-table.scss";
import { withNavigation } from "../withNavigate";
import EditMessage from "../editMessage/editMessage";
import "./messages.scss";
import orangeSpinner from "../loader/orange_spinner.svg";
import addIcon from "../messages/add-icon.svg";
import { TimeZone } from "../utils";

const MessageTable = ({
  project,
  robot,
  vehicle,
  user,
  className,
  navigate,
}) => {
  const [showEditMessage, setShowEditMessage] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [messages, setMessages] = useState([]);
  const prevShowEditMessageRef = useRef(false);
  const goToMessages = () => {
    if (!project || !project._id) return;
    const projectId = project._id;
    navigate(`/messages?project=${projectId}`);
  };

  const showEditMessageClicked = (message) => {
    setShowEditMessage(true);
    setSelectedMessage(message);
  };

  const createNewMessage = () => {
    if (!project || !project._id) {
      console.error("Cannot create message: project is not available");
      return;
    }

    const newMessage = {
      projectId: project._id,
      created: Date.now(),
      expiryDate: Date.now(),
      description: "",
      level: 1,
    };

    // Only include vehicleId if vehicle exists
    if (vehicle && vehicle._id) {
      newMessage.vehicleId = vehicle._id;
    }

    setSelectedMessage(newMessage);
    setShowEditMessage(true);
  };

  const getMessages = async () => {
    if (!project || !project._id) {
      console.log("Cannot load messages: project is not available");
      return;
    }

    console.log(",,,,", project, vehicle, robot);
    let url = `${HOST_URL}/api/messages?projectId=${
      project._id
    }&expiryDate=${Date.now()}`;
    if (vehicle && vehicle._id) url += `&vehicleId=${vehicle._id}`;

    if (robot && robot._id) url += `&robotId=${robot._id}`;

    const authToken = localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);

    try {
      const response = await axios.get(url, {
        headers: { Authorization: authToken },
      });
      setMessages(response.data.messages);
    } catch (error) {
      console.error("Error loading messages:", error);
      setMessages([]);
    }
  };

  useEffect(() => {
    getMessages();
  }, [project, vehicle, robot]);

  // Reload messages when the edit modal closes (after saving)
  useEffect(() => {
    // Only reload if the modal was previously open and is now closed
    if (prevShowEditMessageRef.current && !showEditMessage) {
      // Modal was closed, reload messages to show any new/updated messages
      getMessages();
    }
    // Update the ref to track the current state
    prevShowEditMessageRef.current = showEditMessage;
  }, [showEditMessage]);

  return (
    <div className={`messages ${className || ""}`}>
      {showEditMessage && (
        <EditMessage
          closeEditMessage={() => setShowEditMessage(false)}
          message={selectedMessage}
        />
      )}

      <div className="header">
        <span className="title" onClick={goToMessages}>
          MESSAGES
        </span>
        {user.role !== "projectOwner" ? (
          <div className="new-message-button" onClick={createNewMessage}>
            <img src={addIcon} />
            NEW MESSAGE
          </div>
        ) : null}
      </div>

      <div className="body ">
        {messages.map((message, index) => {
          return (
            <div
              className={"message level" + message.level}
              key={index}
              onClick={() => showEditMessageClicked(message)}
            >
              <span className="circle">
                {message.level === 0 ? <img src={checkIcon} /> : "!"}
              </span>
              <div className="right-side">
                <div className="error-title">{message.description}</div>
                <div className="error-description">
                  {project
                    ? new TimeZone(project).getLocalTime(message.created, true)
                    : ""}
                </div>
              </div>
            </div>
          );
        })}
        {!messages.length && <div className="no-messages">No messages</div>}
      </div>
    </div>
  );
};

export default withNavigation(MessageTable);
